import { analytics, type AnalyticsEventProperties } from '@/analytics/client';

type AnalyticsOutcome = 'attempted' | 'succeeded' | 'failed';

type AnalyticsEventName = 'app_page_viewed' | 'appointment_booked';

function errorType(error: unknown) {
  if (error && typeof error === 'object' && 'code' in error && typeof error.code === 'string') {
    return error.code;
  }

  return error instanceof Error ? error.name : 'unknown_error';
}

export function trackEvent(eventName: AnalyticsEventName, properties: AnalyticsEventProperties = {}) {
  analytics.track(eventName, properties);
}

export function trackOutcome(
  eventName: AnalyticsEventName,
  outcome: AnalyticsOutcome,
  properties: AnalyticsEventProperties = {},
) {
  trackEvent(eventName, {
    ...properties,
    outcome,
  });
}

export function trackFailure(
  eventName: AnalyticsEventName,
  error: unknown,
  properties: AnalyticsEventProperties = {},
) {
  trackOutcome(eventName, 'failed', {
    ...properties,
    error_type: errorType(error),
  });
}
